export const JOIN_CODE_LENGTH = 8;

/**
 * Codes get typed by hand, pasted with the grouping dash, or read aloud, so the
 * client normalises the same way the server does before sending it.
 */
export function normalizeJoinCode(value: string): string {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

/** `ABCD2345` reads as `ABCD-2345`; only for display, never for sending. */
export function formatJoinCode(code: string): string {
  const clean = normalizeJoinCode(code);
  return clean.length === JOIN_CODE_LENGTH ? `${clean.slice(0, 4)}-${clean.slice(4)}` : clean;
}
